'use strict';
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.default = void 0;
  
  var _FileOutlined = _interopRequireDefault(require('./lib/icons/FileOutlined'));
  
  function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
  
  var _default = _FileOutlined;
  exports.default = _default;
  module.exports = _default;


//////////////////
// WEBPACK FOOTER
// ./~/@ant-design/icons/FileOutlined.js
// module id = 1202
// module chunks = 0